import React, { useContext, useState } from 'react'
import { Box, Typography, Container, Button, useMediaQuery, useTheme, Card, AppBar, Toolbar, Tooltip, Grid } from '@mui/material'
import BusinessCard from './BusinessCard'
import { FormsFeatureContext, IValidationError } from '@ngt/forms/src'
import { useParams } from 'react-router/dist'
import useBusinessCardByGuid from '../../hooks/useBusinessCardByGuid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons'
import Logo from '../../assets/img/bctlogo.png'
import { ASMHomePage } from '@/constants/constants'
import ErrorView from '../form/inputs/ErrorView'
import RegistrationField from '../RegistrationField'
import { useScopedField } from '@ngt/forms-core/src'
import { ValidationErrorType } from "@ngt/forms"; // Ensure this is imported

interface IExportButtonProps {
    link: string;
    disabled?: boolean;
    children?:  React.ReactNode;
}

const AddToContactsButton: React.FC<IExportButtonProps> = ({link, disabled, children}) => {
    return (
        <Button
            href={link}
            disabled={disabled}
            aria-label='Export virtual business card to contacts list'
            endIcon={<FontAwesomeIcon icon={faUserPlus} />} 
            sx={{
                mt: 10,
                display: 'flex', 
                marginLeft: 'auto',
                marginRight: 'auto',
                width: 210,
                height: 70,
                alignItems: 'center', 
                justifyContent: 'center' 
            }}
        >
            <Typography sx={{ fontWeight: 'bold', mr: 1 }}>
                Add To Contacts
            </Typography> 
        </Button>     
    );
};

const CardPage = () => {

    const { serviceStackClient } = useContext(FormsFeatureContext)
    const params = useParams()
    const registrationGuid = params?.guid
    const response = useBusinessCardByGuid(registrationGuid)
    const data = response?.data
    const theme = useTheme()

    interface IErrorFields {
        errorFields: string[];
    }


    if (!data) {
        return (
            <ErrorView 
                view={'Alert'}
                hasErrors={true}
                errors={[{ 
                    message: "User did not consent to share this data.", 
                    type: ValidationErrorType.Normal 
                }]}
                errorType={ValidationErrorType.Normal}
                disabled={false}
                FieldInputProps={{} as any} 
            />
        );
    }

    return (
        <>
            <AppBar color='inherit' position='fixed' style={{ width: '100%', backgroundColor: 'common.white', paddingBottom: 10 }}>
                <Toolbar>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mt: 1,
                                width: {
                                    xs: '100px',
                                    md: '120px'
                                },
                                '& img': {
                                    width: '100%'
                                }
                            }}
                        >
                            <a href='/'>
                                <img
                                    src={Logo}
                                    alt='BCT logo'
                                    width={150}
                                    height={74}
                                    loading='lazy'
                                    decoding='async'
                                    srcSet={`${Logo} 150w, ${Logo} 250w`}
                                    sizes='(max-width: 650px) 100px, 120px'
                                    style={{ height: 'auto' }}
                                />
                            </a>
                        </Box>
                        <Typography
                            fontSize={'1.5rem'}
                            sx={{
                                fontWeight: 550,
                                color: theme.palette.primary.main,
                                ml: 4,
                                mt: 1
                            }}
                        >
                            BCT ASM {new Date().getFullYear()}
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box sx={{ width: '100%', height: '100%', mt: { xs: 13, md: 15 }, display: 'flex', justifyContent: 'center' }}>
                <BusinessCard {...data} />
            </Box>

            <AddToContactsButton link={`/card/export/${registrationGuid}`} />
        </>
    )
}
export default CardPage
